export const SORT_EDITOR_LOCALE = {
    // åæ¶
    cancel: 'Cancel',
    // ç¡®å®
    ok: 'OK',
    // æ·»å å­å¥
    add: 'Add',
    clear: 'Clear',
    // ç½®é¡¶
    moveTop: 'Top',
    // ä¸ç§»
    moveUp: 'Up',
    // ä¸ç§»
    moveDown: 'Down',
    // ç½®åº
    moveBottom: 'Bottom',

    // å­æ®µ
    field: 'Field Name',
    // æä½ç¬¦
    order: 'Order',

    asc: 'ASC',
    desc: 'DESC',
    title: 'Sort Editor',
    clearAll: 'Are you sure you want to clear all sorting fields?'
};
